import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchConnections } from "../../redux/actions/connections";

const formatCount = (count) => Number(count || 0).toLocaleString();

const ShopConnectionStats = ({ userId, profileType = "Shop" }) => {
  const dispatch = useDispatch();
  const { followers, following, isLoadingFollowers, isLoadingFollowing } = useSelector(
    (state) => state.connections
  );

  useEffect(() => {
    if (!userId || !profileType) {
      return;
    }

    dispatch(fetchConnections(userId, profileType, "followers"));
    dispatch(fetchConnections(userId, profileType, "following"));
  }, [dispatch, userId, profileType]);

  const followerCount = Array.isArray(followers) ? followers.length : 0;
  const followingCount = Array.isArray(following) ? following.length : 0;

  return (
    <div
      className="shop-profile-connection-stats"
      aria-label={`${followerCount} followers and ${followingCount} following`}
    >
      <div className="shop-profile-connection-stat">
        <span className="shop-profile-connection-stat-value">
          {isLoadingFollowers ? "..." : formatCount(followerCount)}
        </span>
        <span className="shop-profile-connection-stat-label">
          {followerCount === 1 ? "Follower" : "Followers"}
        </span>
      </div>
      <div className="shop-profile-connection-stat">
        <span className="shop-profile-connection-stat-value">
          {isLoadingFollowing ? "..." : formatCount(followingCount)}
        </span>
        <span className="shop-profile-connection-stat-label">Following</span>
      </div>
    </div>
  );
};

export default ShopConnectionStats;